import classNames from 'classnames';
import React from 'react';

export function ContentContainer({ children, className }: React.PropsWithChildren<{ className?: string }>) {
    return <div className={classNames('max-w-[100vw] px-5 lg:w-auto lg:w-full lg:p-0', className)}>{children}</div>;
}
